import * as React from "react";
type Props = {
  className?: string,
};
function SvgFacebook({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Facebook"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8889 2H3.11111C2.5 2 2 2.5 2 3.11111V20.8889C2 21.5 2.5 22 3.11111 22H12.6889V14.2222H10.0778V11.2333H12.6889V9.01111V9.02222C12.4778 7.03333 13.9333 5.24444 15.9222 5.03333C16.1333 5.01111 16.3444 5.01111 16.5556 5.02222H16.6111C17.3667 5.02222 18.1111 5.06667 18.8556 5.14444L18.9 7.83333H17.3C16.0444 7.83333 15.8 8.43333 15.8 9.3V11.2222H18.7889L18.4 14.2222H15.8V22H20.8889C21.5 22 22 21.5 22 20.8889V3.11111C22 2.5 21.5 2 20.8889 2Z"
        fill="#3973DD"
      />
    </svg>
  );
}
export default SvgFacebook;
